// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import PaymentMethod from '../_raw/service/icon_payment_method.svg';
import withIconProps from '../withIconProps';

export default withIconProps(PaymentMethod);
